import React from 'react'
import { shallow } from 'enzyme'
import RefreshTableButton from '../subComponents/RefreshTableButton.jsx'

describe('Refresh Table Button Component', () => {
  it('should match snapshot', () => {
    const wrapper = shallow(<RefreshTableButton handleReFetch={jest.fn()} />)
    expect(wrapper).toMatchSnapshot()
  })

  it('should match snapshot', () => {
    const wrapper = shallow(<RefreshTableButton handleReFetch={jest.fn()} />)
    const button = wrapper.find('.refreshTableBtn')
    button.simulate('click')
    expect(wrapper.exists()).toBe(true)
  })
})
